import { observable } from 'mobx';
import { useMount } from 'ahooks';
import { noop } from '@src/utils/common-util';

class MessageModalStore {
  onClose = noop;
  /**
   * 图片模式
   * @type {{horizontal: number, vertical: number}}
   */
  IMG_MODE = {
    vertical: 0,
    horizontal: 1
  };

  @observable mode = this.IMG_MODE.horizontal;
  /**
   * 模态框显示状态
   * @type {boolean}
   */
  @observable modalStatus = true;
  /**
   * message内容
   */
  @observable messageImg;

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  use() {
    useMount(() => {
      this.modalStatus = true;
    });
  }
}

export default MessageModalStore;
